<template>
  <div class="home p-3">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <div class="d-flex flex-wrap">
      <div
         class="col-4"
         v-for="item in infoItems"
         :key="item.id"
         >
         <h4>{{item.title}}</h4>
         <p>{{item.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
     return {
        infoItems: [
           {id: 1, title: "Title 1", description: "Laborum voluptate et pariatur veniam. Veniam aute non et ut qui minim nulla deserunt ullamco anim veniam aute dolore. Est cupidatat cupidatat laboris sunt nulla velit sunt in ullamco quis ad velit nulla. Eiusmod ea exercitation et minim cillum minim nulla consectetur laborum cupidatat ipsum esse eiusmod."},
           {id: 2, title: "Title 2", description: "Laborum voluptate et pariatur veniam. Veniam aute non et ut qui minim nulla deserunt ullamco anim veniam aute dolore. Est cupidatat cupidatat laboris sunt nulla velit sunt in ullamco quis ad velit nulla. Eiusmod ea exercitation et minim cillum minim nulla consectetur laborum cupidatat ipsum esse eiusmod."},
           {id: 3, title: "Title 3", description: "Laborum voluptate et pariatur veniam. Veniam aute non et ut qui minim nulla deserunt ullamco anim veniam aute dolore. Est cupidatat cupidatat laboris sunt nulla velit sunt in ullamco quis ad velit nulla. Eiusmod ea exercitation et minim cillum minim nulla consectetur laborum cupidatat ipsum esse eiusmod."},
           {id: 4, title: "Title 4", description: "Laborum voluptate et pariatur veniam. Veniam aute non et ut qui minim nulla deserunt ullamco anim veniam aute dolore. Est cupidatat cupidatat laboris sunt nulla velit sunt in ullamco quis ad velit nulla. Eiusmod ea exercitation et minim cillum minim nulla consectetur laborum cupidatat ipsum esse eiusmod."},
        ]
     }
  },
   props: {
      languageIsEnglish: { type: Boolean, required: true }
   }
}
</script>

<style lang="scss" scoped>
* {
   box-sizing: border-box;
}
</style>